export default __webpack_public_path__ + "static/media/playering3.12f9c5ec.png";